import { useEffect, useState } from "react";
import LayeredDashboardHeader from "../LayeredDashboardHeader";
import { useNavigate } from "react-router-dom";
import LayeredDashboardModal from "./Modals/LayeredDashboardModal";
import CreateAction from "../../components/operational/createAction";
import PrimaryButton from "../../components/ui/PrimaryButton";
import SmartBannerPhone from "../../components/ui/SmartBannerPhone";
import HexColor from "../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/HexColor";
import SecondaryButton from "../../components/ui/SecondaryButton";
import { useSelector } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import useCustomNavigate from "../../components/operational/goBack";

const getScript = (subdomain) => {

  const scriptText = `<script src="https://mobligo-bucket.s3.eu-central-1.amazonaws.com/mobligo_smart_banner.js" id="mobligo_smart_banner" data-subdomain="${subdomain}"></script>`
  return scriptText
}
function copyScriptAsText(subdomain) {
  // Get the text field
  const scriptText = getScript(subdomain)
  // Select the text field

  // Copy the text inside the text field
  navigator.clipboard.writeText(scriptText);

  alert("Kopyalandı!")


}

const baseSettings = {
  "buttonColor": "#7059ef",
  "buttonTextColor": "#fff",
  "backgroundColor": "#000",
  "textColor": "#fff",
  "bannerLocation": "bottom",
  isFixed: true,
  hideOnScroll: true,
  pushContent: true
}

const SmartBanner = ({ tab }) => {

  const goBack = useCustomNavigate(tab)

  const myAppsData = useSelector((state) => state.myAppsSlice.localReduxData)

  const app = myAppsData?.app


  const [customization, setCustomization] = useState(baseSettings)
  const [appData, setAppData] = useState({ reference: "Powered by mobligo", buttonText: "Yükle", iosLink: "", androidLink: "", appName: app.mobileAppName })


  useEffect(() => {
    getSmartBanner();
  }, []);

  const getSmartBanner = async () => {
    try {
      const response = await fetch(`https://mobligo-bucket.s3.eu-central-1.amazonaws.com/smartBanner/${app.mobligoSubdomain}.json?p=${(new Date().getTime())}`)
      const renderData = await response.json()
      if (renderData) {
        setAppData(renderData)
        if (renderData?.data?.style) {
          setCustomization({ ...customization, ...renderData?.data?.style })

        }
      }
    } catch {

    }
  }

  const updateSmartBanner = async () => {
    const response = await CreateAction({
      method: "patch",
      path: `/smartbanner`,
      showPreLoader: true,
      data: {
        ...appData, data: { ...(appData?.datastyle || {}), style: { ...customization } }
      }
    }

    )
    if (response.error)
      return


    goBack()

  }
  const setItem = (value, key) => {
    setCustomization(state => ({ ...state, [key]: value }))
  }
  return (<>
    <LayeredDashboardHeader onSave={updateSmartBanner} tab={tab}>

    </LayeredDashboardHeader>
    <div className='w-full h-[calc(100dvh-60px)] overflow-auto scrollbar-y-visible'>
      <div className="p-[20px] flex justify-center items-center">
        <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
          <div className="flex flex-col w-full gap-[15px] px-[20px]">
            <div className="flex flex-col gap-[15px] items-center py-[32px] ">

              <div className="font-medium text-[24px]">
                Smart Banner
              </div>
              <div className="font-semibold text-gray-500 text-[14px]">
                Websitenize mobil uygulama bağlantılarınız için bir pop-up yerleştirin!
              </div>

            </div>
            <div className="flex flex-row gap-[20px]">
              <textarea className="w-full border-2 p-3 rounded-[5px] " value={getScript(app.mobligoSubdomain)}>
              </textarea>

              <div className=" justify-center items-center flex-1 flex">
                <PrimaryButton onClick={() => copyScriptAsText(app.mobligoSubdomain)} value={"Kopyala"} classes="!h-[40px]"></PrimaryButton>
              </div>
            </div>
            <div className="grid grid-cols-2 mt-[40px]">
              <div className='flex flex-col w-full gap-[10px]'>
                <div className="w-full" >
                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">IOS Linki</label>
                  <input value={appData.iosLink} onChange={(e) => setAppData(state => ({ ...state, ["iosLink"]: e.target.value }))} type="text" id="first_name" class="bg-white border border-1 border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " placeholder="IOS Linki" required />
                </div>
                <div className="w-full" >
                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Android Linki</label>
                  <input value={appData.androidLink} onChange={(e) => setAppData(state => ({ ...state, ["androidLink"]: e.target.value }))} type="text" id="first_name" class="bg-white border border-1 border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " placeholder="Android Linki" required />
                </div>
                <div className="w-full" >
                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Buton Yazısı</label>
                  <input value={appData.buttonText} onChange={(e) => setAppData(state => ({ ...state, ["buttonText"]: e.target.value }))} type="text" id="first_name" class="bg-white border border-1 border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " placeholder="Buton Yazısı" required />
                </div>
                <HexColor setItem={setItem} value={customization["buttonColor"]} id={customization["buttonColor"]} targetKey={"buttonColor"} componentType={"SmartBanner"} hideBorder={true} />
                <HexColor setItem={setItem} value={customization["buttonTextColor"]} id={customization["buttonTextColor"]} targetKey={"buttonTextColor"} componentType={"SmartBanner"} hideBorder={true} />
                <HexColor setItem={setItem} value={customization["backgroundColor"]} id={customization["backgroundColor"]} targetKey={"backgroundColor"} componentType={"SmartBanner"} hideBorder={true} />
                <HexColor setItem={setItem} value={customization["textColor"]} id={customization["textColor"]} targetKey={"textColor"} componentType={"SmartBanner"} hideBorder={true} />

                <div className="w-full" >

                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Sayfayı Kaydırınca</label>

                  <div className="flex flex-row gap-[30px]">
                    <PrimaryButton onClick={() => { setItem(false, "hideOnScroll") }} classes={`${!customization.hideOnScroll ? "" : "bg-white text-black hover:bg-white"}`} value={"Açık Kalsın"}></PrimaryButton>
                    <PrimaryButton onClick={() => { setItem(true, "hideOnScroll") }} classes={`${customization.hideOnScroll ? "" : "bg-white text-black hover:bg-white"}`} value={"Kapansın"}></PrimaryButton>
                  </div>
                </div>

                <div className="w-full" >
                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Banner Konumu</label>
                  <div className="flex flex-row gap-[30px]">
                    <PrimaryButton onClick={() => { setItem("top", "bannerLocation") }} classes={`${customization.bannerLocation === "top" ? "" : "bg-white text-black hover:bg-white"}`} value={"Üst"}></PrimaryButton>
                    <PrimaryButton onClick={() => { setItem("bottom", "bannerLocation") }} classes={`${customization.bannerLocation === "bottom" ? "" : "bg-white text-black hover:bg-white"}`} value={"Alt"}></PrimaryButton>
                  </div>


                </div>
                {customization.bannerLocation === "top" &&
                  <div className="w-full" >

                    <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Banner Pozisyonu</label>

                    <div className="flex flex-row gap-[30px]">
                      <PrimaryButton onClick={() => { setItem(true, "isFixed") }} classes={`${customization.isFixed ? "" : "bg-white text-black hover:bg-white"}`} value={"Sabit"}></PrimaryButton>
                      <PrimaryButton onClick={() => { setItem(false, "isFixed") }} classes={`${!customization.isFixed ? "" : "bg-white text-black hover:bg-white"}`} value={"Statik"}></PrimaryButton>
                    </div>
                  </div>

                }
                {customization.bannerLocation === "top" && customization?.isFixed &&
                  <div className="w-full" >

                    <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">Sayfaya Göre Konumu</label>

                    <div className="flex flex-row gap-[30px]">
                      <PrimaryButton onClick={() => { setItem(true, "pushContent") }} classes={`${customization.pushContent ? "" : "bg-white text-black hover:bg-white"}`} value={"Sayfayı aşağıya mı itsin?"}></PrimaryButton>
                      <PrimaryButton onClick={() => { setItem(false, "pushContent") }} classes={`${!customization.pushContent ? "" : "bg-white text-black hover:bg-white"}`} value={"Sayfanın üzerine mi açılsın?"}></PrimaryButton>
                    </div>
                  </div>

                }

              </div>
              <SmartBannerPhone customization={customization} appData={appData} />
            </div>
          </div>
        </div>
      </div>
    </div >


  </>)
};

export default SmartBanner;
